<template>
  <div class="Login d-flex flex-column justify-content-center">
    <div class="row justify-content-center mt--50">
      <div class="col-12 text-center">
        <img
          alt="logo"
          src="/images/logo/logo.png"
          width="100%;"
          style="max-width: 450px;"
        />
      </div>
      <div class="col-md-6 col-10 text-center mt-4" style="max-width: 430px;">
        <div class="input-group-prepend">
          <span class="input-group-text2" id="basic-addon">
            <i class="fas fa-user prefix mb-1 ml-1"></i>
          </span>
          <input
            id="full_name"
            type="text"
            v-model="full_name"
            class="form-control2"
            placeholder="Full Name"
            @keypress="isCharacter($event)"
          />
        </div>
        <div class="input-group-prepend mt-3">
          <span class="input-group-text2" id="basic-addon">
            <i class="fas fa-user prefix mb-1 ml-1"></i>
          </span>
          <input
            id="username"
            type="text"
            v-model="username"
            class="form-control2"
            placeholder="Username"
            @keypress="isCharacter2($event)"
          />
        </div>
        <div class="input-group-prepend mt-3">
          <span class="input-group-text2" id="basic-addon">
            <i class="fas fa-lock prefix mb-1 ml-1"></i>
          </span>
          <input
            id="password"
            type="password"
            v-model="password"
            class="form-control2"
            placeholder="Password"
          />
        </div>
        <div class="input-group-prepend mt-3">
          <span class="input-group-text2" id="basic-addon">
            <i class="fas fa-lock prefix mb-1 ml-1"></i>
          </span>
          <input
            id="passwordagain"
            type="password"
            v-model="passwordagain"
            class="form-control2"
            placeholder="Password (again)"
          />
        </div>
        <div class="input-group-prepend mt-3">
          <span class="input-group-text2" id="basic-addon">
            <i class="fas fa-mobile-alt prefix mb-1 ml-1"></i>
          </span>
          <input
            id="phone"
            type="text"
            v-model="phone"
            class="form-control2"
            placeholder="Phone"
            maxlength="10"
            @keypress="isNumber($event)"
          />
        </div>
        <div class="input-group-prepend mt-3">
          <span class="input-group-text2" id="basic-addon">
            <i class="fas fa-building prefix mb-1 ml-1"></i>
          </span>
          <input
            id="company"
            type="text"
            v-model="company"
            class="form-control2"
            placeholder="Company"
          />
        </div>
        <div class="row">
          <div class="col-6">
            <router-link to="/Login">
              <mdb-btn class="btn-register-ok color_back font16" block
                >ย้อนกลับ</mdb-btn
              >
            </router-link>
          </div>
          <div class="col-6">
            <mdb-btn
              class="btn-register-cancle font16"
              block
              @click="register()"
              >สมัครสมาชิก</mdb-btn
            >
          </div>
        </div>
      </div>
    </div>
    <nav class="navbar-bottom fixed-bottom py-3">
      <div class="row justify-content-center" style="z-index:1;">
        <img class="image1" src="/images/bg2.png" />
      </div>
      <div class="row justify-content-center" style="z-index:2;">
        <img class="image1" src="/images/bg.png" />
      </div>
    </nav>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions } from "vuex";
const jwt = require("jsonwebtoken");
import moment from "moment";
export default {
  data() {
    return {
      full_name: "",
      username: "",
      password: "",
      passwordagain: "",
      phone: "",
      company: "",
    };
  },
  methods: {
    ...mapActions({
      storeLogin: "login",
    }),
    isCharacter: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        (charCode != 32 && charCode < 65) ||
        (charCode > 90 && charCode < 97) ||
        charCode > 122
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isCharacter2: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode < 48 ||
        (charCode > 57 && charCode < 65) ||
        (charCode > 90 && charCode < 97) ||
        charCode > 122
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    check_condition: function() {
      this.errors = [];
      // Check username
      if (this.username.length == "") {
        this.errors.push("กรุณากรอกชื่อผู้ใช้งาน");
        return this.$swal({
          icon: "warning",
          title: "ชื่อผู้ใช้งาน",
          text: "กรุณากรอกชื่อผู้ใช้งาน",
          timer: 5000,
          showConfirmButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      }

      //Check password
      if (this.password.length < 8) {
        this.errors.push("กรุณากรอกรหัสผ่าน 8 - 16 ตัว");
        return this.$swal({
          icon: "warning",
          title: "รหัสผ่าน",
          text: "กรุณากรอกรหัสผ่าน 8 - 16 ตัว",
          timer: 5000,
          showConfirmButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      } else {
        let msg = [false, false, false];
        for (let index = 0; index < this.password.length; index++) {
          if (
            this.password.charCodeAt(index) >= 48 &&
            this.password.charCodeAt(index) <= 57
          ) {
            msg[0] = true;
          } else if (
            this.password.charCodeAt(index) >= 65 &&
            this.password.charCodeAt(index) <= 90
          ) {
            msg[1] = true;
          } else if (
            this.password.charCodeAt(index) >= 97 &&
            this.password.charCodeAt(index) <= 122
          ) {
            msg[2] = true;
          }
        }
        if (msg[0] && msg[1] && msg[2]) {
          console.log("1");
        } else {
          this.errors.push(
            "กรุณากรอกรหัสผ่านที่มีพิมพ์เล็กพิมพ์ใหญ่และตัวเลขผสมกัน"
          );
          return this.$swal({
            icon: "warning",
            title: "รหัสผ่าน",
            text: "กรุณากรอกรหัสผ่านที่มีพิมพ์เล็กพิมพ์ใหญ่และตัวเลขผสมกัน",
            timer: 5000,
            showConfirmButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
          });
        }
      }

      //Check againpassword
      if (this.password != this.passwordagain) {
        this.errors.push("รหัสผ่านกับยืนยันรหัสผ่านไม่ตรงกัน");
        return this.$swal({
          icon: "warning",
          title: "ยืนยันรหัสผ่าน",
          text: "รหัสผ่านกับยืนยันรหัสผ่านไม่ตรงกัน",
          timer: 5000,
          showConfirmButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      }

      // Check phonenumber
      if (this.phone.length !== 10) {
        this.errors.push("กรุณากรอกเบอร์โทรศัพท์ให้ครบ 10 หลัก");
        return this.$swal({
          icon: "warning",
          title: "เบอร์โทรศัพท์",
          text: "กรุณากรอกเบอร์โทรศัพท์ให้ครบ 10 หลัก",
          timer: 5000,
          showConfirmButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      } else if (this.phone[0] !== "0") {
        this.errors.push("เบอร์โทรศัพท์ต้องขึ้นต้นด้วย 0 เท่านั้น");
        return this.$swal({
          icon: "warning",
          title: "เบอร์โทรศัพท์",
          text: "เบอร์โทรศัพท์ต้องขึ้นต้นด้วย 0 เท่านั้น",
          timer: 5000,
          showConfirmButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      } else if (this.phone[0] === "0") {
        if (
          this.phone[1] === "8" ||
          this.phone[1] === "9" ||
          this.phone[1] === "6"
        ) {
          //  this.$router.push("/");
        } else {
          this.errors.push(
            "เบอร์โทรศัพท์ต้องขึ้นต้นด้วย 06 หรือ 08 หรือ 09 เท่านั้น"
          );
          return this.$swal({
            icon: "warning",
            title: "เบอร์โทรศัพท์",
            text: "เบอร์โทรศัพท์ต้องขึ้นต้นด้วย 06 หรือ 08 หรือ 09 เท่านั้น",
            timer: 5000,
            showConfirmButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
          });
        }
      }

      //  Check company
      if (this.company === "") {
        this.errors.push("กรุณากรอกชื่อหน่วยงาน");
        return this.$swal({
          icon: "warning",
          title: "ชื่อหน่วยงาน",
          text: "กรุณากรอกชื่อหน่วยงาน",
          timer: 5000,
          showConfirmButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      }
    },
    async register() {
      await this.check_condition();
      if (this.errors.length <= 0) {
        let payload = {
          date_regis: moment(new Date()).format("Y-MM-DD hh:mm:ss"),
          full_name: this.full_name,
          username: this.username,
          password: this.password,
          phone_number: this.phone,
          company_name: this.company,
          ip_address: this.ipuser,
        };
        console.log(payload);
        let token = jwt.sign(payload, this.$keypayload, {
          expiresIn: "5555555s",
        });
        console.log(this.$keypayload);
        this.$axios
          .put("/register", { token: token })
          .then((response) => {
            if (response.data.code != 1) {
              this.$swal({
                icon: "success",
                title: "สมัครสำเร็จ",
                html: response.data.msg,
                timer: 5000,
                showConfirmButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
              });
              this.login();
            } else {
              this.$swal({
                icon: "error",
                title: "สมัครไม่สำเร็จ",
                html: response.data.msg,
                timer: 5000,
                showConfirmButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
              });
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    login: function() {
      let payload = {
        username: this.username,
        password: this.password,
        ip_login: this.ipuser,
      };
      let token = jwt.sign(payload, this.$keypayload, {
        expiresIn: "5555555s",
      });
      console.log(payload);
      this.$axios
        .post("/login", { token: token })
        .then((response) => {
          if (response.data) {
            this.$session.set("isLogin", true);
            this.$session.set("token", response.data);
            this.storeLogin(response.data);
            this.$router.push("/Setupsender");
          } else {
            this.$swal({
              title: "เข้าสู่ระบบ",
              text: response.data.msg,
              icon: "error",
              timer: false,
              showConfirmButton: true,
              allowOutsideClick: false,
              allowEscapeKey: false,
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
  },
  mounted() {
    let apiGetIp = "https://api.ipify.org";
    axios
      .get(apiGetIp)
      .then((response) => {
        this.ipuser = "" + response.data;
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
</script>

<style>
.Login {
  background: #131313;
  height: 100vh;
  width: 100%;
  position: relative;
  overflow-x: hidden;
}
.btn-register-cancle {
  color: #ffffff;
  background-color: #f5904b !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25),
    inset 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 18px !important;
  padding: 10px 15px 10px 15px;
  margin-top: 30px !important;
}
.btn-register-ok {
  color: #000000;
  background-color: #f2f2f2 !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25),
    inset 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 18px !important;
  padding: 10px 15px 10px 15px;
  margin-top: 30px !important;
}
</style>
